import { AnimationReferenceMetadata, transition, trigger, useAnimation } from '@angular/animations';
import { Component, OnInit, inject } from '@angular/core';
import { fadeInRight } from 'ng-animate';
import { FitupService } from '../../../shared/service/fitup/fitup.service';
import { ResponsiveService } from '../../../shared/service/fitup/responsive.service';
import { ThinkModelComponent, Image, IList } from '../../../shared/model/fitup/generic.model';

@Component({
  selector: 'app-modern-function',
  templateUrl: './modern-function.component.html',
  styleUrls: ['./modern-function.component.scss'],
  animations: [
    trigger('fadeInRight', [transition('* => *', useAnimation(fadeInRight, {
      // Set the duration to 5seconds and delay to 0seconds
      params: { timing: 1.5, delay: 1 }
    }))])
  ],
})
export class ModernFunctionComponent implements OnInit {
  private readonly _fitUpSvc = inject(FitupService)
  private readonly _responsiveSvc = inject(ResponsiveService)
  public screenSize$ = this._responsiveSvc.screenSize$
  fadeInRight?: AnimationReferenceMetadata;
  appModernFunction?: ThinkModelComponent;
  headText?: string;
  subText?: string;
  functionImage?: Image;
  functionList?: IList[];
  alternativeTextFunction!: string;

  ngOnInit(): void {
    this.getDados()
  }

  getDados(): void {
    this._fitUpSvc.getStrapiDataObservable().subscribe(updateData => {
      this.appModernFunction = updateData
      const component = this._fitUpSvc.getComponentData('app_modern_function').data.attributes
      this.functionImage = component.functionImage
      this.alternativeTextFunction = component.functionImage.data.attributes.alternativeText
      this.headText = component.headText
      this.subText = component.subText
      this.functionList = component.functionList.functionLi
    })
  }
}
